export default __webpack_public_path__ + "static/media/somerston_logo.30bd14b1.png";